import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    TraceSourceRowDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";

const stylesheet = StyleSheet.create({
    index: {
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0
    },
    line: {
        alignItems: "center",
        flexDirection: "row",
        flexShrink: 1,
        minWidth: 0
    },
    indexText: {
        fontVariant: [
            "tabular-nums"
        ]
    },
    title: {
        flexShrink: 1
    },
    description: {
        flexShrink: 0
    },
    end: {
        flexShrink: 0
    }
});

export const useStyles = ({
    shapeConfigs,
    iconSizes,
    radiuses,
    colors,
    spaces
}: TraceSourceRowDynamicStyleType) => {
    const styles = {
        index: {
            backgroundColor: colors.content.container.subtle,
            paddingHorizontal: spaces.spacingXxs,
            ...getCornerStyle({
                radius: radiuses.form / 2,
                shapeConfigs
            }),
            minWidth: iconSizes.small,
            height: iconSizes.small
        } as Mutable<ViewStyle>,
        description: {
            marginStart: spaces.spacingXs
        } as Mutable<ViewStyle>,
        line: {
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
